<template>
  <b-container fluid id="rodape">
    <div id="barraRodape"></div>
    <b-container id="conteudoRodape">
      <b-row>
        <b-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          xl="6"
          class="mb-4 mb-md-0 mb-lg-0 mb-xl-0"
        >
          <h6>{{ tituloRodape }}</h6>
          <p v-html="descricaoRodape"></p>
        </b-col>
        <b-col
          id="logoRodape"
          cols="12"
          sm="12"
          md="6"
          lg="6"
          xl="6"
          class="mb-4 mb-md-0 mb-lg-0 mb-xl-0"
          :class="logoRodapeClient"
        >
          <a
            class="text-sm-center text-center text-md-left text-lg-right text-xl-right d-block"
            :href="logoRodapeLink"
            target="_blank"
          >
            <img
              class="img-fluid"
              :src="logoRodape"
              :title="logoRodapeTitulo"
              :alt="logoRodapeTitulo"
            />
          </a>
        </b-col>
      </b-row>
    </b-container>
    <div id="rodapeBGOver"></div>
    <div id="rodapeBGPattern"></div>
  </b-container>
</template>

<script>
  import client from '@/main.js'
  export default {
    data() {
      return {
        client: null,
        tituloRodape: 'Prefeitura Municipal de Cuiabá',
        descricaoRodape: '',
        logoRodape: '',
        logoRodapeTitulo: '',
        logoRodapeLink: ''
      }
    },
    created() {
      let me = this
      me.client = client.CLIENT
      me.tituloRodape = client.clientData.footer.footerTitle
      me.descricaoRodape = client.clientData.footer.footerDescription
      me.logoRodape = require('@/assets/imagens/' +
        me.client +
        '/rodapeLogo.png')
      me.logoRodapeTitulo = client.clientData.footer.footerLogoTitle
      me.logoRodapeTitulo = client.clientData.footer.footerLink
    },
    computed: {
      logoRodapeClient() {
        return this.client === 'DOE-AL' ? 'logoRodapeDOEAL' : 'logoRodapeAll'
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/estilos.scss';
  #rodape {
    position: relative;
    background-color: $corRodape;
    min-height: 190px;
    color: #fff;
    #barraRodape {
      margin-left: -15px;
      margin-right: -15px;
      width: calc(100% + 30px);
      height: 6px;
      background-color: $corBordaRodape;
    }
    #conteudoRodape {
      position: relative;
      padding-top: 50px;
      padding-bottom: 30px;
      h6 {
        font-size: 18px;
        font-weight: bold;
      }
      p {
        font-size: 14px;
      }
      z-index: 3;
      .logoRodapeDOEAL {
        margin-top: -60px;
      }
      .logoRodapeAll {
        margin-top: -30px;
      }
    }
    #rodapeBGOver {
      position: absolute;
      background-color: #ccc;
      top: 6px;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0.1;
      mix-blend-mode: multiply;
      z-index: 2;
    }
    #rodapeBGPattern {
      position: absolute;
      top: 6px;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0.4;
      background-image: url('../../assets/imagens/rodapefdopattern.png');
      background-repeat: repeat-x;
      mix-blend-mode: soft-light;
      z-index: 1;
    }
    /* Media Queries */
    @media (min-width: 768px) {
      #conteudoRodape {
        #logoRodape {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    /* xs and sm */
    @media (max-width: 767.98px) {
      #conteudoRodape {
        .logoRodapeDOEAL,
        .logoRodapeAll {
          margin-top: 0;
        }
      }
    }
    /* Tablets */
    /* iPad */
    @media (min-width: 768px) and (max-width: 991.98px) {
      #conteudoRodape {
        .logoRodapeDOEAL,
        .logoRodapeAll {
          margin-top: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/rodape.vue